import React from 'react'
import Header from '../../subcategory/Header'
import SubCard from '../../../../../comon/SubCard'
import BalasanaImg from '../../../../../assets/images/yoga/balasana.png'
import DhanurasanaImg from '../../../../../assets/images/yoga/dhanurasana.png'
import { useTranslation } from 'react-i18next'

const BackPain = () => {
    const {t} = useTranslation();
    return (
        <>
        <Header headtitle={t("yoga.backpainyoga")} />
        <SubCard fitImg={BalasanaImg} title={t("Balasana.title")} context={false} workoutLink='/balasana' />
        <SubCard fitImg={DhanurasanaImg} title={t("Dhanurasana.title")} context={false} workoutLink='/dhanurasana' />
        </>
      )
    }

export default BackPain
